import { useSnapshot } from 'valtio';

import { refsStore, poiStore } from '../managers/globalState';
import { POI_CATEGORIES } from '../config/constants';
//import momenti from "moment-hijri";
import moment from 'moment-timezone';

const updateYear = newYearIndex => {
	poiStore.setGlobalState({ yearIndex: newYearIndex });
};

const updateCategory = category => {
	poiStore.setGlobalState({ categoryIndex: category });
};

/**
 * Loops through all the poi and creates an array of all years spanning them.
 * @param {Array} allPoI
 * @returns {Array}
 */
const  getAllYearsPoI = allPoI => {
	let allYears = [['all','كل السنوات']];

	allPoI.map(poi => {
		const currYear = poi.date.substring(0, 4);
		let all = allYears.filter(v => {
			return v[0] == currYear
		})
		if(all.length == 0){
			const display = moment(poi.date).locale('en'). format('YYYY');
			allYears.push([currYear,display]);
		}
	});

	return allYears.sort((a, b) => b - a);
};

const filterPoI = ( pois, poiYears, yearIndex, poicategoryIndex) => {
  // console.log("filter!!!!!!!!!", pois, yearIndex, poicategoryIndex)
  return pois.filter(poi => {
      if(POI_CATEGORIES.length > 0){
        const year = poiYears[yearIndex][0];
        const category = POI_CATEGORIES[poicategoryIndex];
        const yearFilter = year === 'all' || poi.date.substring(0, 4) === year;
        const categoryFilter = category[0] === 'All Types' || (poi.imagecategory?.includes(category[0].replace(/ /g, '').toLocaleLowerCase()));
        return yearFilter && categoryFilter;
      }
  })};

export {
	updateYear,
	updateCategory,
	getAllYearsPoI,
	filterPoI
};
